module.exports = __webpack_public_path__ + "img/empty_documents.156e351c.svg";